import { Text, Section, Picture, Grid, GridItem } from '@farmersdog/corgi-x';

import { arrowIconSources } from '../assets/arrowIcon';
import { secondBoxSources } from '../assets/secondBox';
import { trialPeriodSources } from '../assets/trialPeriod';

import styles from './GettingStarted.module.css';
import { GettingStartedCard } from './GettingStartedCard';

interface GettingStartedProps {
  petName: string;
  petDailyDiscountedSubtotal: string;
  petDailySubtotal: string;
  discountPercentage: number | null;
}

/** "Getting Started" section of the Signup Recipes page */
export function GettingStarted({
  petName,
  petDailySubtotal,
  petDailyDiscountedSubtotal,
  discountPercentage,
}: GettingStartedProps) {
  const trialOrderBadges = discountPercentage
    ? ['Bulk Discount', `${discountPercentage}% Discount`]
    : ['Bulk Discount'];
  return (
    <Section
      aria-labelledby="Getting Started"
      className={styles.gettingStartedContainer}
      vSpacing="lg"
    >
      <Text
        className={styles.eyebrow}
        as="h3"
        variant="heading-12"
        align="center"
        bottomSpacing="xs"
        bold
      >
        How it Works
      </Text>
      <Text as="h2" align="center" variant="heading-40" bold>
        Getting Started
      </Text>
      <Grid
        alignItems="stretch"
        justifyContent="center"
        flexDirection={{
          xs: 'column',
          lg: 'row',
        }}
        columnGap="md"
        rowGap="md"
        topSpacing={{
          xs: 'md',
          lg: 'lg',
        }}
        className={styles.cardContainer}
      >
        <GridItem sm={12} md={12} lg={3}>
          <GettingStartedCard
            badges={trialOrderBadges}
            headline="Trial Period"
            imageSources={trialPeriodSources}
            imageAltText="Trial box with packs"
            listItems={[
              `Learn ${petName}’s favorite recipes`,
              `Transition ${petName} to personalized portions`,
            ]}
            strikeoutPrice={`${petDailySubtotal}/day`}
            actualPrice={`${petDailyDiscountedSubtotal}/day`}
          />
        </GridItem>
        <GridItem sm={12} md={12} lg={3}>
          <GettingStartedCard
            badges={['Bulk Discount']}
            headline="Second Box"
            imageSources={secondBoxSources}
            imageAltText="Feeding second box to dogs"
            listItems={[
              `Ensure you're feeding ${petName}’s favorite recipe`,
              'Adjust your plan and delivery details',
            ]}
            actualPrice={`${petDailySubtotal}/day`}
          />
        </GridItem>
        <div className={styles.arrowWrapper}>
          <Picture
            className={styles.arrowIcon}
            alt="arrow"
            sources={arrowIconSources}
          />
        </div>
        {/* TODO: Replace placeholder with Popular Plan Options 
        https://app.shortcut.com/farmersdog/story/135748/
        */}
        <GridItem sm={12} md={12} lg={3}>
          <GettingStartedCard
            headline="Placeholder"
            imageSources={secondBoxSources}
            imageAltText="Delete me"
            actualPrice="0.00"
            listItems={[`Foo`, 'Bar']}
          />
        </GridItem>
      </Grid>
    </Section>
  );
}
